import React from 'react';

import {
  Avatar,
  Button,
  SimpleCell,
  Spacing,
  Text,
  Title,
} from '@vkontakte/vkui';

import styles from './MobileAfterUserChoosePage.module.css';
import { MobileAfterUserChoosePageProps } from './types';
import { PaymentLayout } from '../../../panels/PredictionPanel/MobilePredictionPanel/components/PaymentLayout';

export const MobileAfterUserChoosePage: React.FC<MobileAfterUserChoosePageProps> = ({
  onGetResultHandler,
  delayAnimation = 0,
  friend,
  ref
}) => {
  if (!friend) {
    return null;
  }

  const invitationText = friend.isSelectedUserPurchased ? (
    'Вы уже купили предсказание для этого пользователя!'
  ) : (
    'Оплатите голосами и узнайте, что страницы людей говорят об их профессональном типе'
  );

  const buttonText = friend.isSelectedUserPurchased ? 'Узнать результаты' : 'Оплатить и узнать результаты';

  return (
    <PaymentLayout
      delayAnimation={delayAnimation}
      ref={ref}
      needBuyingDescription={!Boolean(friend.isSelectedUserPurchased)}
      style={{ width: '100%' }}
    >
      <div className={styles.container}>
        <Spacing size={40} />

        <Title 
          level="2"
          weight="2"
          className={styles.chooseTitle}
        >
        Вы выбрали пользователя:
        </Title>

        <SimpleCell
          disabled
          before={<Avatar size={48} src={friend.photoSrc} />}
          subtitle={friend.subtitle}
          className={styles.avatarCell}
        >
          {friend.name}
        </SimpleCell>

        <Text className={styles.text}>
          {invitationText}
        </Text>

        <Spacing size={16} style={{ marginBottom: '8px' }} />

        <Button
          size="l"
          mode="primary"
          onClick={onGetResultHandler}
          className={styles.button}
        >
          {buttonText}
        </Button>

        <Spacing size={30} />

      </div>
    </PaymentLayout>
  );
};
